/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n){const{associationType:t}=n;return"connectivity"===t||"junction-junction-connectivity"===t||"junction-edge-from-connectivity"===t||"junction-edge-midspan-connectivity"===t||"junction-edge-to-connectivity"===t}export{n as isConnectivity};
